module.exports = __webpack_public_path__ + "static/1_1_dark-33efd3d51fff24d166195007d3bc18f8.png";